<template>
    <div class="select-wrapper">
        <q-select
            v-model="internalValue"
            dense
            outlined
            :name="undefined"
            :data-cy="name"
            v-bind="filteredAttrs"
            :options="filteredOptions"
            @filter="filterFn"
            emit-value
            map-options
        >
            <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope || {}"></slot>
            </template>
        </q-select>
        <input
            ref="hiddenInput"
            v-if="name"
            type="hidden"
            :name="name"
            :value="internalValue !== null && internalValue !== undefined ? internalValue : ''"
        />
    </div>
</template>

<script>
import { ref, watch, computed, nextTick } from "vue";

export default {
    name: "SelectWrapper",
    inheritAttrs: false,
    props: {
        modelValue: [String, Number, Array],
        name: String,
        options: {
            type: Array,
            default: () => [],
        },
    },
    setup(props, { attrs }) {
        const hiddenInput = ref(null);
        const internalValue = ref(props.modelValue);

        watch(
            () => props.modelValue,
            (val) => {
                internalValue.value = val;
            },
        );

        watch(
            () => internalValue.value,
            () => {
                nextTick(() => {
                    if (hiddenInput.value) {
                        hiddenInput.value.dispatchEvent(new Event("input", { bubbles: true }));
                        hiddenInput.value.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                });
            },
        );

        const filteredOptions = ref(props.options);

        watch(
            () => props.options,
            (val) => {
                filteredOptions.value = val || [];
            },
        );

        const filterFn = (val, update) => {
            if (val === "") {
                update(() => {
                    filteredOptions.value = props.options;
                });
                return;
            }

            update(() => {
                const needle = val.toLowerCase();
                filteredOptions.value = props.options.filter(
                    (v) => v.label.toLowerCase().indexOf(needle) > -1,
                );
            });
        };

        const filteredAttrs = computed(() => {
            const { options, ...rest } = attrs;
            return rest;
        });

        return { hiddenInput, internalValue, filteredOptions, filterFn, filteredAttrs };
    },
};
</script>
